import { useEffect, useState } from 'react'

import api from '../../utils/api'

import './ExclusaoConta.css'

function ExclusaoConta() {
    const [whatsapp, setWhatsapp] = useState(null)

    useEffect(() => {
        api.get('/configuracao/contato').then((response) => {
            setWhatsapp(response.data.contato?.whatsapp || null)
        }).catch(() => setWhatsapp(null))
    }, [])

    return (
        <div className="exclusao">
            <p className="exclusao-eyebrow">Legal</p>
            <h1 className="exclusao-title">Exclusão de conta e dados — Planeta Arena</h1>

            <div className="exclusao-content">
                <h2>Como solicitar</h2>
                <p>
                    Para excluir sua conta do Planeta Arena e os dados associados a ela, entre em contato informando
                    o email ou nome de usuário cadastrado:
                </p>
                <ul>
                    {whatsapp && (
                        <li>
                            Pelo WhatsApp: <a href={`https://wa.me/55${whatsapp}`} target="_blank" rel="noreferrer">clique aqui para conversar</a>
                        </li>
                    )}
                    <li>
                        Por email: <a href="mailto:planeta-arena@deltabyte.com.br">planeta-arena@deltabyte.com.br</a>
                    </li>
                </ul>

                <h2>O que acontece depois</h2>
                <p>
                    Em até 30 dias após a solicitação, excluímos permanentemente seus dados pessoais de cadastro
                    (nome, email, telefone, data de nascimento e senha) e desativamos o acesso à conta.
                </p>

                <h2>Dados excluídos</h2>
                <ul>
                    <li>Dados de cadastro (nome, email, telefone, data de nascimento, senha)</li>
                    <li>Identificador do dispositivo vinculado à conta</li>
                    <li>Posição no ranking e estatísticas de jogo (pontuação, eliminações, mortes, vitórias, derrotas)</li>
                    <li>Progresso do cartão fidelidade</li>
                </ul>

                <h2>Dados que podem ser mantidos</h2>
                <p>
                    Registros de compras e presença já realizados no espaço físico podem ser mantidos por período
                    adicional quando exigido por obrigação legal ou contábil, mesmo após a exclusão da conta. Fora
                    dessas exceções, não retemos dados pessoais depois de concluída a exclusão.
                </p>
            </div>
        </div>
    )
}

export default ExclusaoConta
